<template>
  <div class="content">
    <div class="lct-class">
      <div class="tu-class">
        <CustomerInformation  ref="childForm"  v-if="fromType == 1" :childId="id" :childProcessId="processId" :fromType="1"></CustomerInformation>
        <ShippingInformation  ref="childForm"  v-if="fromType == 2" :childId="id" :childProcessId="processId" :fromType="2"  :form-data.sync="childFormData"></ShippingInformation>
        <OutEntrepot  ref="childForm"  v-if="fromType == 3" :childId="id" :childProcessId="processId" :fromType="3" ></OutEntrepot>
      </div>
    </div>
  </div>
</template>
<script>
import ShippingInformation from '../../components/flowForm/shippingInformation.vue';
import CustomerInformation from '../../components/flowForm/customerInformation.vue';
import OutEntrepot from '../../components/flowForm/outEntrepot.vue';

export default {
  components: {  ShippingInformation,CustomerInformation,OutEntrepot},
  name:'processTransaction',
  data() {
    return{
    }
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style scoped lang="less">
.zhantie{
  width: 50%;
  height: 230px;
  border: 1px solid #DCDFE6;
  overflow: hidden;
  margin-top: 22px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size:14px;
    color: #C0C4CC;
  }
}
.imgclass{
  width: 300px;
  height: 100px;
}
.lct-class{
  padding-bottom: 50px;
  .detail-h3 {
    font-size: 20px;
    color: #000000;
    padding-bottom: 30px;
    box-sizing: border-box;
  }
  .detail-h3 i {
    color: #5298ff;
  }
  .nr-class{
    margin-top: 20px;
    margin-left: 10px;
  }
  .yjp-class{
    margin-top: 20px;
  }
}
</style>


